import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Image } from "@/components/image";

export const Route = createFileRoute("/_auth")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<div className="flex flex-row h-full md:overflow-y-auto md:max-h-screen">
			<div className="flex-1 p-6 lg:flex lg:items-center lg:justify-center">
				<Outlet />
			</div>

			<div className="flex-1 bg-primary/10 font-semibold flex-col gap-6 h-screen sticky max-md:hidden top-0 flex items-center justify-center">
				<Image
					src="https://storage.googleapis.com/scarf-club-assets/landing/scarf-system.svg"
					className="max-w-[500px]"
					width={500}
				/>
			</div>
		</div>
	);
}
